import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

// Utility function to generate table headers
const generateTableHeaders = (columns) => {
  return columns
    ?.map((col) => col.title)
    ?.filter((header) => header !== "Actions" && header !== "Sl No");
};
const formatNumber = (value, decimalpoints) => {
  return typeof value === "number" && decimalpoints !== undefined
    ? value.toFixed(decimalpoints)
    : value;
};
// Utility function to generate table body rows
const generateTableBody = (data, tableHeaders, fieldMapping,cardname) => {
  return data?.map((item) => {
    console.log("data",data)
    return tableHeaders?.map((header) => {
      const field = fieldMapping[header];
      let value = field?.includes(".")
        ? field.split(".").reduce((obj, key) => obj && obj[key], item)
        : item[field];

      if (field === "transactionDate") {
        value = dayjs(value).format("DD-MM-YY"); // Format the date
      }
      // if (field === "billDate") {
      //   value = dayjs(value).format("DD-MM-YY"); // Format the date
      // }
if (field === "billDate" || field === "lastUpdate") {
  if (dayjs(value).isValid()) {
    return dayjs(value).format("HH:mm");
  }
  return "";
}
      if (field === "editDate") {
        value = dayjs(value).format("DD-MM-YY"); // Format the date
      }
      if (field === "date") {
        value = dayjs(value).format("DD-MM-YY"); // Format the date
      }
      if (field === "entryDate") {
        value = dayjs(value).format("DD-MM-YY"); // Format the date
      }
      if (field === "section") {
        value = item?.section?.name; // Get product name
      }
      if (field === "paymentCardType.cardName") {
        value = item.paymentCardType?.cardName || "N/A";
      }
      
      if (field === "counter") {
        value = item?.counter?.name; // Get unit name
      }
      if (field === "category") {
        value = item?.category?.name; // Get unit name
      }
      if (field === "type") {
        value = item?.type ; // Get unit name
      }
      if (field === "paymentType") {
        value =
          item?.paymentType === 0
            ? "Cash"
            : item?.paymentType === 1
            ? "Card"
            : item?.paymentType === 2
            ? "Bank"
            : item?.paymentType === 3
            ? "Credit"
            : item?.paymentType === 4
            ? "UPI"
            : "None";
      }
      if (field === "paymenCardType") {
        value = item?.paymenCardType?.cardName; // Get unit name
      }
      if (field === "user") {
        value = item?.user?.name; // Get unit name
      }
      if (field === "salesStatus") {
        value =
          item?.salesStatus === 0
            ? "completed"
            : item?.salesStatus === 1
            ? "pending"
            : "Unknown";
      }
      if (field === "branch") {
        value = item?.branch?.name;
      }
      if (field === "product") {
        value = item?.product?.name;
      }
      if (field === "customer") {
        value = item?.customer?.name; // Get unit name
      }
      if (field === "ledgerName") {
        value = item?.ledgerName?.name;
      }
      return value;
    });
  });
};



// PDF Export
export const exportreportPDF = (getActiveTabData,footerTotals,companyInfolist) => {
  const { data, columns, fieldMapping,decimalpoints,Rname,fromDate, toDate} = getActiveTabData();
  console.log(data,"pdffffffffffffff");
  console.log(companyInfolist,"COMPANYNAME");
  console.log("columns", columns);
  console.log("fieldMapping", fieldMapping);
  // Set orientation based on the number of columns (e.g., more than 5 columns -> landscape)
  const orientation = columns?.length > 9 ? "landscape" : "portrait";

  // Initialize jsPDF with the dynamic orientation
  const doc = new jsPDF({
    orientation: orientation,
  });
  // const branchName = data?.[0].branch?.name || "Branch Name Not Available";
 // const branchName = data?.find(item => item?.branch?.name)?.branch?.name || "Branch Name Not Available";
const branchName = data?.[0]?.branch?.name || "Branch Not Available";

 console.log("branch",branchName)
//  const companyName = companyInfolist?.[0].name || "Company Name Not Available";
const companyName = companyInfolist?.find(company => company?.name)?.name || "Company Name Not Available";

 console.log("company",companyName)

   const formattedFrom = dayjs(fromDate).format("DD-MM-YYYY");
  const formattedTo = dayjs(toDate).format("DD-MM-YYYY");
  // Add title and branch name to the PDF
  doc.setFontSize(16);
  doc.text(`${Rname}`, 14, 20); // Report title
 
  doc.setFontSize(10);
  doc.text(`Company: ${companyName}`, 14, 29); // Branch name
  doc.setFontSize(10);
  doc.text(`Branch: ${branchName}`, 14, 38); // company name
    doc.text(`From: ${formattedFrom}`, 14, 48);
  doc.text(`To: ${formattedTo}`, 80, 48);
  // Generate table headers and body
  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(data, tableHeaders, fieldMapping);
  const footerRow =
  footerTotals &&
  tableHeaders.some((header) => footerTotals[fieldMapping[header]])
    ? tableHeaders.map((header) =>
        formatNumber(footerTotals[fieldMapping[header]] || decimalpoints)
      )
    : null;
  // Use autoTable to export the table
  // autoTable(doc, {
  //   head: [tableHeaders],
  //   body: tableBody,
  // });
  autoTable(doc, {
    head: [tableHeaders],
    body: tableBody,
    ...(footerRow ? { foot: [footerRow] } : {}),
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 3 },
    headStyles: { fillColor: [63, 81, 181] }, // Indigo
    startY: 55, // Start below the branch name
  });

  // Save the PDF
  doc.save(`${Rname}.pdf`);
  
};

// Excel Export
// export const exportreportExcel = (getActiveTabData, name) => {
//   const { data, columns, fieldMapping } = getActiveTabData();
//   const tableHeaders = generateTableHeaders(columns);
//   const tableBody = Array.isArray(data)
//     ? generateTableBody(data, tableHeaders, fieldMapping)
//     : [];
//   console.log("tableHeaders", tableHeaders);
//   console.log("tableBody", tableBody);
//   if (!Array.isArray(tableBody)) {
//     console.error("Error: Table Body is not an array.");
//     return;
//   }
//   const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...tableBody]);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
//   XLSX.writeFile(workbook, `${name}.xlsx `);
// };

/////////////////
export const exportreportExcel = (getActiveTabData,footerTotals,companyInfolist) => {
  const { data, columns, fieldMapping,decimalpoints,Rname} = getActiveTabData();
 // Extract branch and company name
//  const branchName = data?.[0]?.branch?.name || "Branch Name Not Available";
//const branchName = data?.find(item => item?.branch?.name)?.branch?.name || "Branch Name Not Available";
const branchName = data?.[0]?.branch?.name || "Branch Not Available";

const companyName = companyInfolist?.find(company => company?.name)?.name || "Company Name Not Available";

//  const companyName = data?.[0]?.branch?.company || "Company Name Not Available";
  // Generate table headers and body
  const tableHeaders = generateTableHeaders(columns);
  const tableBody = Array.isArray(data)
    ? generateTableBody(data, tableHeaders, fieldMapping)
    : [];



  // if (!Array.isArray(tableBody)) {
  //   console.error("Error: Table Body is not an array.");
  //   return;
  // }

  // Clean up data
  const sanitizedBody = tableBody.map(row => 
    row.map(cell => (cell == null ? "" : cell)) // Replace null/undefined with empty string
  );
  const footerRow = footerTotals
    ? tableHeaders.map(header=>
        formatNumber(footerTotals[fieldMapping[header]] ||  decimalpoints)
      )
    : null;

  const fullTable = footerRow ? [...sanitizedBody, footerRow] : sanitizedBody;
  try {
    const preamble = [
      [`Company: ${companyName}`],
      [`Branch: ${branchName}`],
      [], // Blank row for spacing
    ];
    const worksheet = XLSX.utils.aoa_to_sheet([...preamble,tableHeaders, ...fullTable]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
    XLSX.writeFile(workbook, `${Rname}.xlsx`);
  } catch (error) {
    console.error("Error generating Excel file:", error);
  }
};

////////////////

// Printable format
export const printreportReport = (getActiveTabData) => {
  const { data, columns, fieldMapping,Rname } = getActiveTabData();
  const printWindow = window.open("", "_blank");

  // Prepare the document for printing
  printWindow.document.write("<html><head><title>Print Report</title>");
  printWindow.document.write("<style>");
  printWindow.document.write(`
        table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
        }
        th {
            background-color: #f2f2f2;
        }
    `);
  printWindow.document.write("</style></head><body>");
  printWindow.document.write(`<h1>${Rname}</h1>`);

  const tableHeaders = generateTableHeaders(columns);
  let tableHTML = "<table><thead><tr>";
  tableHeaders.forEach((header) => {
    tableHTML += `<th>${header}</th>`;
  });
  tableHTML += "</tr></thead><tbody>";

  const tableBody = generateTableBody(data, tableHeaders, fieldMapping);
  tableBody.forEach((row) => {
    tableHTML += "<tr>";
    row.forEach((cell) => {
      tableHTML += `<td>${cell}</td>`;
    });
    tableHTML += "</tr>";
  });
  tableHTML += "</tbody></table>";

  printWindow.document.write(tableHTML);
  printWindow.document.write("</body></html>");

  printWindow.document.close();
  printWindow.print();
};
